/* eslint-disable quotes */

const domains = {
  header: {
    title: 'ドメインマネージャー',
    add_domain: '[ドメインを追加]',
    mail_flow: 'メールの流れ',
    domains: 'ドメイン'
  },
  table: {
    domain_name: '[ドメイン名]',
    status: 'ステータス',
    aliases: 'エイリアス',
    recipients: '受信者 (過去 30 日間)',
    mail_servers: 'メールサーバー',
    settings: '[設定]',
    domain_options: 'ドメインオプション',
    no_records_available: '使用可能なレコードはありません',
    no_mail_servers_defined: 'メールサーバーが定義されていません'
  },
  actions: {
    edit: '[編集]',
    manage: '管理',
    remove: '[削除]',
    helpdesk: 'ヘルプデスク'
  },
  status: {
    unverified: '未確認',
    verified: 'ドメインが確認され、MXレコード経由でメールが流れている。',
    misconfigured: 'ドメインが確認されました。MXレコードがバラクーダを指していない',
    inline_verified: '確認済み',
    inline_misconfigured:
      '検証済みですが、MXレコードはバラクーダを指しています。インライン展開は送信者認証の問題を引き起こします。'
  },
  mx_banner: {
    text: '1 つまたは複数のドメインの MX レコードが正しく設定されていません。これにより、バラクーダネットワークスがお客様のドメインを脅威やスパムから保護できなくなる可能性があります。',
    learn_more: 'さらに詳しく'
  },
  tooltip: {
    misconfigured:
      'このドメインのすべての MX レコードを、バラクーダネットワークスを指すように設定します。上のバナーのリンクをクリックしてください。',
    unique_settings: 'ドメイン固有のポリシー'
  },
  enabled: '有効',
  disabled: '無効',
  details: {
    mx_records_configuration: 'MX レコード設定',
    outbound_smarthost_configuration: 'アウトバウンドスマートホスト構成',
    aliases: 'エイリアス',
    email_continuity: 'Eメールの継続',
    domain_specific_policies: 'ドメイン固有のポリシー',
    reset_to_account_policies: 'アカウントポリシーにリセット',
    account_policies: 'アカウントポリシー',
    primary: 'プライマリ',
    backup: '[バックアップ]',
    hostname: 'ホスト名'
  },
  add_domain: {
    title: '[ドメインを追加]',
    domain_name: '[ドメイン名]',
    mail_server: 'メールサーバー',
    cancel: '[キャンセル]',
    add: '[ドメインを追加]',
    invalid_domain: '有効なドメイン名を入力してください。',
    missing_mail_server: 'メールサーバーのホストを少なくとも 1 つ入力してください。',
    invalid_mail_server: 'ホスト名が無効です',
    tld_warning: '入力されたドメイン名には TLD がありません。このドメインを追加してよろしいですか?',
    blacklisted_domain_name: 'このドメイン名は追加できません。'
  },
  add_mail_server: {
    title: 'メールサーバーの追加',
    mail_server: 'メールサーバー',
    preference: '優先度',
    cancel: '[キャンセル]',
    add: 'メールサーバーの追加'
  },
  delete_domain_confirm: {
    title: '確認が必要です',
    message:
      'このドメインを削除してよろしいですか?ドメインを削除すると、関連する設定と認証ステータスがすべて削除されます。',
    outbound_ip_conflict: 'この IP のアウトバウンドログエントリを削除または変更してください。',
    only_verified_domain: 'このドメインはアウトバウンドメールを送信できなくなります。続けますか?'
  },
  edit_domain: {
    header: {
      title: 'ドメイン設定'
    },
    mail_servers: {
      title: 'メールサーバー',
      description: '複数のメールサーバーを指定した場合、各サーバーは優先順位の高い順に試行されます。',
      address: 'メールサーバー (IP アドレスまたはホスト名)',
      priority: '優先度',
      test: 'テスト',
      edit: '[編集]',
      remove: '[削除]',
      add: '追加',
      cancel: '[キャンセル]',
      update: '[更新]',
      mx_server_configuration: 'MX サーバー構成',
      primary: 'プライマリ',
      backup: '[バックアップ]',
      outbound_smarthost_configuration: 'アウトバウンドスマートホスト構成',
      hostname: 'ホスト名',
      empty_host: 'メールサーバーのホストを少なくとも 1 つ入力してください。',
      invalid_host: 'ホスト名が無効です',
      invalid_preference: '優先度が無効です。',
      send: '送信',
      empty_recipient: '受取人の名前を入力します。',
      email_send_failure: 'この受信者へのテスト E メールの送信に失敗しました',
      test_configuration: 'テスト構成',
      confirm_removal: '削除を確認',
      confirm_removal_body: '<span>{サーバー名}</span> を削除してよろしいですか'
    },
    save: '[保存]',
    cancel: '[キャンセル]',
    alias: {
      title: 'ドメインエイリアス'
    },
    domain_select_label: 'ドメインを選択',
    domain_select_description: 'このドメインをのエイリアスにする',
    domain_select_loading: '利用可能なドメインをロード中...',
    domain_select_empty_value: '[なし]',
    domain_select_helper: 'ドメインエイリアシングとユーザーエイリアスを同時に使用しないでください。',
    domain_select_error: '利用可能なドメインを読み込めませんでした',
    options: {
      title: '[オプション]',
      yes: 'はい',
      no: 'いいえ',
      spooling: {
        label: 'スプーリング'
      },
      user_auto_add: {
        label: 'ユーザーを自動的に追加',
        helper: '注:無効なユーザー作成を防ぐには、メールサーバーで受信者検証を有効にしてください。'
      },
      enable_sender_proof_protection: {
        label: '送信者なりすまし保護を有効にする'
      },
      rewrite_recipients_for_aliased_domains: {
        label: 'エイリアスドメインの受信者の書き換え'
      }
    },
    directory_services: {
      title: 'ディレクトリサービス',
      description:
        'Azure AD または LDAP ディレクトリサービスのいずれかを使用して、シングルサインオンとユーザーリストの同期を有効にできます。',
      type: {
        label: 'タイプ'
      },
      types: {
        none: '[なし]',
        azure_ad: 'アズール AD',
        ldap: 'LDAP'
      },
      azure_ad: {
        status: 'ステータス',
        not_authorized: '未承認',
        authorize: '[承認]',
        authorized: 'アクティブ',
        revoke_authorization: '承認を取り消す',
        tenant_status_error: 'テナントステータスのクエリに失敗しました',
        authorized_account: '承認済みアカウント',
        authorization_date: '承認日',
        directory_options: 'ディレクトリオプション',
        synchronization_options: {
          label: '同期オプション',
          manual: '[マニュアル]',
          automatic: '自動的に同期'
        },
        sync_now: '今すぐ同期',
        sync_stats:
          '{sync_users_added} ユーザーが追加されました、{sync_users_updated} ユーザーが更新されました、{sync_users_deleted} ユーザーが削除されました',
        sync_status: {
          hidden: ' ',
          currently_in_progress: '同期は現在進行中です。{sync_stats}',
          completed: '同期は {sync_finished_at}, {sync_stats} で終了しました',
          already_in_progress: '現在同期中',
          still_syncing: '同期はまだ進行中です。これまでのところ {sync_stats}'
        },
        sso: {
          label: 'シングルサインオンを有効にする',
          yes: 'はい',
          no: 'いいえ'
        },
        test_azure_ad_settings: {
          title: 'Azure AD 構成設定のテスト',
          label: 'テスト用メールアドレス',
          helper: {
            note: 'Azure AD 設定のテストのみを目的としています。有効なプライマリメールアドレスを入力してください。'
          },
          button: 'テスト設定',
          empty_username: 'テストするメールアドレスを入力してください',
          invalid_username: 'メールアドレスのユーザー名部分のみを入力してください'
        }
      },
      ldap: {
        ldap_configuration: {
          title: 'LDAP コンフィギュレーション',
          host: 'LDAP ホスト',
          port: 'ポート',
          use_ssl: 'SSL (LDAPS) を使用する',
          use_ssl_yes: 'はい',
          use_ssl_no: 'いいえ',
          ldap_username: 'バインド DN/ユーザー名',
          ldap_password: '[パスワード]',
          ldap_base_dn: 'ベース DN',
          ldap_base_dn_helper:
            "ディレクトリのベース DN。次の値を代用できます。'{default_naming_context}': ドメインが test.com の場合、ベース DN は DC=test、DC=com である可能性があります。",
          ldap_mail_attributes: 'メール属性',
          ldap_mail_attributes_helper:
            '電子メールアドレスを含む属性のコンマ区切りリスト。例:メール、SAM アカウント名、プロキシアドレス',
          test_config: 'LDAP 構成設定のテスト',
          testing_email_address: 'テスト用メールアドレス',
          testing_email_address_helper:
            'LDAP 設定のテスト専用です。有効なプライマリメールアドレスを入力してください。空欄の場合、テストは接続に限定されます。',
          test_settings: 'テスト設定'
        },
        directory_options: {
          title: 'ディレクトリオプション',
          ldap_sync: '自動的に同期',
          ldap_sync_yes: 'はい',
          ldap_sync_no: 'いいえ',
          ldap_sync_helper: '最後に終了した同期:{last_ldap_sync}',
          sync_now: '今すぐ同期',
          ldap_auth: '認証に LDAP を使用する',
          ldap_auth_yes: 'はい',
          ldap_auth_no: 'いいえ',
          auth_filter: '認証フィルター',
          auth_filter_helper: {
            info: 'メールユーザー認証用の LDAP フィルタリング文字列を指定します。以下の値を代入できます。',
            email_address: "'{email_address}': ユーザーが入力したメールアドレス全体。",
            user_name:
              "'{user_name}': 電子メールアドレスのユーザー名部分、またはユーザーが電子メールアドレスを入力しなかった場合は入力全体。",
            domain_name: "'{domain_name}': メールアドレスのドメイン部分。",
            example:
              "例:(| (mail=' {email_address} ') (userPrincipalName=' {user_name}') (samAccountName=' {user_name} '))"
          }
        },
        advanced_configuration: {
          title: '高度な LDAP 設定',
          domain_limited: 'ユーザーフィルター',
          domain_limited_yes: 'はい',
          domain_limited_no: 'いいえ',
          user_filter: 'カスタムユーザーフィルター',
          user_filter_helper: {
            info: 'メールユーザー同期用の LDAP フィルタリング文字列 (オプション) を指定します。',
            example: '例:(名前=*テスト*)'
          }
        },
        errors: {
          ldap_sync_and_user_auto_add_conflict:
            '自動ユーザー作成と自動 LDAP 同期を同時に使用することはできません。1 つのオプションのみを有効にしてください。',
          ldap_password_missing: '新しい LDAP パスワードを入力してください'
        },
        test: {
          title: 'LDAP コンフィグレーションテスト',
          in_progress: 'LDAP 設定のテストが進行中です...',
          no_host_specified: 'ホストが指定されていません',
          no_bind_dn_specified: 'バインド DN が指定されていません',
          no_password_specified: 'バインドパスワードが指定されていません',
          no_connection: '接続なし',
          bind_failed: 'バインド失敗',
          unknown_error: 'エラーが発生しました',
          connection_successful: '接続に成功しました',
          user_lookup_not_executed: 'ユーザー検索は実行されませんでした',
          user_email_lookup_empty: 'ユーザー検索 (テストメール) で空の結果が返されました',
          user_filter_lookup_empty: 'ユーザー検索 (ユーザーフィルター) が空の結果を返しました',
          user_lookup_successful: 'ユーザー検索成功',
          user_query_title: 'ユーザー {test_email} にクエリを実行すると、次の属性が返されました',
          user_filter_title: 'ユーザーフィルターで最初に見つかったエントリ'
        }
      }
    },
    smtp_encryption: {
      title: 'SMTP 暗号化',
      force_tls_label: 'バラクーダネットワークスからメールサーバーに TLS を使用する:',
      tls_label: '以下のドメインからバラクーダネットワークへの TLS を要求する:',
      never: '決して',
      optional: '[オプション]',
      required: '必須',
      smtp_over_tls: 'TLS 経由の SMTP',
      all_inbound_messages: 'すべての受信メッセージ',
      selected_sender_domains: '送信者ドメインを選択',
      save_changes_helper: '一括編集を有効にするには、変更を保存してください',
      table_description_all:
        'Email Gateway Defense に、特定の送信者ドメインを除くすべてのドメインからの安全な TLS 接続を要求するように強制するには、除外された送信者ドメイン名を入力して [追加] をクリックしてください。',
      table_description_select:
        'Email Gateway Defense に特定の送信者ドメインからの安全な TLS 接続を要求するように強制するには、送信者ドメイン名を入力して [追加] をクリックします。',
      table_sub_description: 'TLS 接続を確立できない場合、メールは受信者ドメインに送信されません。',
      bulk_edit: '一括編集'
    },
    encryption: {
      title: '暗号化',
      validation_status: '検証ステータス',
      validate_cname: 'CNAME を検証',
      validate_post: '郵便局長を検証',
      remove_validation: '検証を削除',
      confirm_validation: '検証を確認',
      unable_to_connect: '暗号化サービスに接続できません。',
      validated: '検証済み',
      not_validated: '未検証',
      pending_cname: '{value} による CNAME の検証は保留中です',
      pending_post: '投稿の検証が保留中です。postmaster@ {value} を確認してください',
      upload_image: '新しい画像をアップロード:',
      choose_file: 'ファイルを選択',
      no_file: 'ファイルが選択されていません',
      remove_file: '現在のロゴを削除',
      upload_image_helper:
        'このドメインのブランド画像。必要なファイルフォーマット:JPG、GIF、または PNG。推奨解像度:160 x 65 ピクセル',
      allow_replies: '返信を許可:',
      read_receipts: '開封確認を有効にする:',
      display_name: 'ドメイン表示名:',
      display_name_helper: 'このドメイン名は暗号化されたメッセージに表示されます。',
      notification_subject: '通知の件名:',
      notification_subject_helper:
        '受信者に送信される暗号化通知の件名。以下のメール部分と同じプレースホルダーを使用できます。',
      text_part: 'テキストパーツ:',
      text_part_helper:
        '受信者に送信されるカスタム通知のテキスト部分。以下の HTML 部分と同じプレースホルダーを使用できます。',
      html_part: 'HTML パーツ:',
      html_part_helper: '受信者に送信されるカスタム通知の HTML 部分。'
    },
    warnings: {
      disable_spooling: {
        title: 'Eメールの継続',
        description:
          'スプーリング機能を無効にすると、このアカウントに関連付けられているすべてのドメインのメールコンティニュイティの自動有効化が無効になります。'
      },
      disable_azure: {
        title: 'Azure AD をオフにする',
        description: {
          info: 'Azure AD を無効にすると、次のような結果になります。',
          consequences: {
            sso: 'バラクーダ ESS でのシングルサインオンは機能しなくなります',
            sync: '新規ユーザーは自動的に同期されません'
          },
          note: '注:受信者検証は引き続き機能します。'
        }
      },
      azure_authorization: {
        title: 'Azure AD をオーソライズ',
        description: {
          info: 'Azure AD ディレクトリサービスにシングルサインオンとユーザーリストの同期を許可するには、管理者アカウントで Office 365 で認証する必要があります。',
          continue: '続行すると、Office 365 に移動してログインできます。',
          permissions: {
            label: 'また、電子メールゲートウェイ防御に次の権限を与える必要があります',
            user_profile: 'ログインしてユーザープロフィールを読む',
            all_groups_read: 'すべてのグループを読む',
            all_groups_write: 'すべてのグループの読み取りと書き込み',
            directory_data_read: 'ディレクトリデータを読み込む',
            directory_data_write: 'ディレクトリデータの読み取りと書き込み',
            all_users_profile_read: 'すべてのユーザーのプロフィールをすべて読む',
            all_users_profile_write: 'すべてのユーザーのフルプロファイルの読み取りと書き込み'
          }
        }
      }
    },
    advanced: {
      title: '高度な構成',
      srs: {
        title: '送信者書き換えスキーム (SRS):',
        yes: 'はい',
        no: 'いいえ'
      },
      ldap_highest_serial: {
        title: '自動的に同期:',
        value: '最も多く見たシリアル:{value}',
        reset: 'リセット'
      }
    }
  },
  verify_domain: {
    header: {
      title: 'ドメイン検証'
    },
    content:
      'Email Gateway Defense を使用してメールをフィルタリングする前に、ドメインを所有証明によって検証する必要があります。',
    options: {
      mx_records: {
        label:
          '<b>MX レコード</b>-ドメインの DNS サーバーに MX レコードを追加している場合は、この方法を選択してください。優先度の低いレコードを追加することが重要です (例:99)。',
        helper: 'MX レコード'
      },
      cname_record: {
        label: '<b>CNAMEレコード</b>-提供されたCNAMEエントリを使用して検証し、ess.barracuda.comを指定してください。',
        helper: 'CNAME トークン'
      },
      postmaster_email: {
        label: '<b>郵便局長への電子メール</b>-確認メールの送信先'
      },
      tech_email: {
        label:
          '<b>ドメインの技術連絡先にメールを送信</b>-ドメインのWHOISエントリに記載されている技術連絡先のメールアドレスに確認メールを送信します。',
        no_record: '技術担当者は見つかりませんでした'
      }
    },
    token_verification: 'ドメインの検証が進行中です...',
    cpl_probe: 'CPL ドメイン検証を開始中...',
    already_verified: 'ドメイン {domainName} はすでに検証されています。',
    already_verified_by_other_account:
      'このドメインはすでに追加され、別のアカウントで検証されています。このドメインがお客様のドメインである場合は、カスタマーサービスに連絡して詳細を問い合わせてください。',
    ok: 'OK',
    next: '[次へ]',
    cancel: '[キャンセル]'
  },
  search_domain: {
    label: '検索',
    hint: 'ドメイン名内のテキストを検索する'
  },
  recipients: {
    header: {
      title: '受信者リスト'
    },
    content: '過去 30 日間に確認されたユニーク受信者',
    go_back: '「ドメインに戻る',
    search_label: '検索',
    search_hint: '特定の受信者または受信者セットを検索する',
    recipient: '受信者',
    no_records_available: '過去 30 日間のユニーク受信者なし',
    no_recipients_found: '<b>{UserIDFilter}</b> がユニーク受信者リストに見つかりませんでした'
  },
  global_reset: {
    title: '確認が必要です',
    description: 'アカウントポリシーのリセットを確認'
  },
  save_setting: {
    inline_deployment: {
      description: '展開方法',
      caption: 'バラクーダでのメールの流れ',
      microsoft_info:
        'Microsoftでインライン導入を完了するには、Microsoftの設定がバラクーダをポイントするように再設定されている必要があります。',
      learn_more: 'さらに詳しく'
    },
    options: {
      microsoft: 'マイクロソフトとのインライン',
      off: 'MXレコード'
    },
    save: '[保存]',
    cancel: '[キャンセル]'
  },
  type_hybrid: 'ハイブリッド',
  transfer_pending: '移管保留中',
  transfer_completed: '転送が完了しました',
  verify_ownership_and_transfer: '所有権の確認と譲渡',
  verify_domain_transfer: {
    title: 'ドメイン移管を確認',
    info: '追加しようとしているドメインは、すでにシステムに存在します。このアカウントへの移管を有効にするには、ドメインの所有者であることを確認してください。',
    cname_record_info: 'ドメインの DNS に、次の内容の CNAME レコードを追加します。',
    hostname: '<b>ホスト名</b>',
    points_to: '<b>ポイント先</b>',
    long_running_info:
      'ドメインの移管が完了するまでに数分かかる場合があります。移管が完了していないようであれば、ドメインマネージャーページのリストを更新してください。',
    cancel: '[キャンセル]',
    verify: '所有権の確認と譲渡',
    back_to_domains: 'ドメインに戻る',
    error: {
      domain_transfer_not_found: 'このドメインに必要な CNAME レコードが見つかりません',
      domain_not_found: 'このドメインは見つかりません',
      domain_not_verified:
        'このドメインは検証されていません。別のアカウントに移管するには、認証済みの状態である必要があります。',
      get_move_domain_failed: '転送状態を取得しようとしてエラーが発生しました',
      domain_transfer_already_complete: 'このドメインは既にこのアカウントに属しています。',
      verify_domain_failed: 'ドメインの検証中にエラーが発生しました',
      graphql_error: 'サーバーに接続してドメインの移動を完了できませんでした。もう一度試してください。',
      cname_record_not_found:
        '現在、ドメインの正しい CNAME レコードが見つかりません。エントリが DNS レコードに追加されていることを確認してください。ISP の設定によっては、変更が反映されるまでに最大 24 時間かかる場合があることに注意してください。',
      transfer_pending: 'ドメインはすでに移管されています。',
      mstore_error: '操作はエラーを返しました:{message}',
      mstore_timeout: '操作がタイムアウトしました'
    }
  }
}

/* eslint-enable quotes */

export default domains
